import { useThemeMode } from '../../../../_metronic/partials'
import './../style/dropdown.scss'
import { toAbsoluteUrl } from '../../../../_metronic/helpers'
import { Link } from 'react-router-dom'
import Skeleton from 'react-loading-skeleton'
import { useIntl } from 'react-intl'
import 'react-loading-skeleton/dist/skeleton.css'

export const SwitchAccount = ({
  userInfo,
  isUserConnected,
  accountType,
  userLoading,
  connectorLoading,
}: any) => {
  const { formatMessage } = useIntl()
  const { mode } = useThemeMode()
  console.log(isUserConnected, ' is user')
  return (
    <div
      className='dropdown-container w-100 p-2 rounded'
      style={mode !== 'dark' ? { background: '#fff' } : { background: '#1e1e2d' }}
    >
      <div className='s-account-heading mt-1 text-black'>
        <p
          className='m-0 fw-semibold'
          style={mode !== 'dark' ? { color: 'black' } : { color: 'white' }}
        >
          {connectorLoading ? (
            <Skeleton
              width={150}
              baseColor='var(--kt-skeleton-bg-color)'
              highlightColor='var(--kt-skeleton-highlight-bg-color)'
            />
          ) : isUserConnected ? (
            formatMessage({ id: 'Connected Account' })
          ) : (
            formatMessage({ id: 'Connect Your Account' })
          )}
        </p>
      </div>
      <div className='s-account-header d-flex align-items-center'>
        {connectorLoading ? (
          <div className='d-flex' style={{ justifyContent: 'center', alignItems: 'center' }}>
            <Skeleton
              circle={true}
              height={40}
              width={40}
              style={{ marginRight: '2px' }}
              baseColor='var(--kt-skeleton-bg-color)'
              highlightColor='var(--kt-skeleton-highlight-bg-color)'
            />
            <Skeleton
              width={150}
              baseColor='var(--kt-skeleton-bg-color)'
              highlightColor='var(--kt-skeleton-highlight-bg-color)'
            />
          </div>
        ) : !isUserConnected ? (
          <>
            <Link to='/setting/company-settings?tab=integration'>
              <img
                src={toAbsoluteUrl('/media/logos/google.svg')}
                alt={formatMessage({ id: 'Google' })}
                className='s-account-image rounded-circle'
              />
            </Link>
            <Link to='/setting/company-settings?tab=integration'>
              <img
                src={toAbsoluteUrl('/media/auth/microsoft-365-logo.svg')}
                alt={formatMessage({ id: 'Microsoft' })}
                className='s-account-image-micro rounded-circle'
              />
            </Link>
          </>
        ) : userLoading ? (
          <div className='d-flex' style={{ justifyContent: 'center', alignItems: 'center' }}>
            <Skeleton
              circle={true}
              height={40}
              width={40}
              style={{ marginRight: '2px' }}
              baseColor='var(--kt-skeleton-bg-color)'
              highlightColor='var(--kt-skeleton-highlight-bg-color)'
            />
            <Skeleton
              width={150}
              baseColor='var(--kt-skeleton-bg-color)'
              highlightColor='var(--kt-skeleton-highlight-bg-color)'
            />
          </div>
        ) : (
          <>
            {accountType === 'nylasGoogle' && (
              <img
                src={toAbsoluteUrl('/media/logos/google.svg')}
                alt={formatMessage({ id: 'Google' })}
                className='s-account-image rounded-circle'
              />
            )}
            {accountType === 'nylasMicrosoft' && (
              <img
                src={toAbsoluteUrl('/media/auth/microsoft-365-logo.svg')}
                alt={formatMessage({ id: 'Microsoft' })}
                className='s-account-image-micro rounded-circle'
              />
            )}
            <div className='dropdown-info ml-2' style={{ overflow: 'hidden' }}>
              <span className='s-account-email'>{userInfo}</span>
            </div>
          </>
        )}
      </div>
    </div>
  )
}
